export default __webpack_public_path__ + "static/media/Win1.10b80f1d.png";